import { string, struct } from 'io-ts/Decoder';

import { Id as TransactionId } from '../../../../../transaction/Id';

export const Params = struct({
	transactionId: TransactionId,
	itemId: string,
});
